require('./RAPortfolioEvolution.scss');

// @vendors
const React = require('react');
const PropTypes = require('prop-types');
const { isEmpty } = require('lodash');

// @components
const RAEvolutionChart = require('../RAEvolutionChart/RAEvolutionChart');
const RAInformativeModal = require('../RAInformativeModal/RAInformativeModal');

// @commons
const { OKLink } = require('commonsComponents/OKLink');
const { ModalCustom } = require('commonsComponents/modalCustom');
const RAPortfolioSelector = require('../commons/RAPortfolioSelector/RAPortfolioSelector');
const { EmptyState } = require('commonsComponents/emptyState');
const { LoadingSection } = require('commonsComponents/loadingSection');

// @utilites
const { formatText, FormattedText } = require('core/i18n').i18n;
const { recordLink } = require('utilities/tagging');

// @constants
const {
    EVOLUTION_MODAL_OPTION_TOTAL,
    GOAL_TRACKING_URL,
    PORTFOLIO_TRACKING_URL,
} = require('../../raConstants/index');

class RAPortfolioEvolution extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showModal: false,
            showEmptyEvolutionModal: false,
        };
        this.handleDisplayModal = this.handleDisplayModal.bind(this);
        this.handleDisplayEmptyEvolutionModal = this.handleDisplayEmptyEvolutionModal.bind(
            this,
        );
    }

    handleDisplayModal() {
        this.setState({
            showModal: !this.state.showModal,
        });
        const toDoOptionValue = {
            label: 'Todas',
            value: '0',
        };
        this.props.changeModalOption(toDoOptionValue);
        recordLink(
            'interaccion en posicion global inversiones',
            'ver evolucion por cartera',
        ); // @TODO: Add logic to origin place
    }

    handleDisplayEmptyEvolutionModal() {
        this.props.onEmptyEvolutionLinkClick();
        this.setState({
            showEmptyEvolutionModal: !this.state.showEmptyEvolutionModal,
        });
    }

    buildModal() {
        const {
            modalData,
            selectedOption,
            modalDisabled,
            selectedPortfolio,
            portfoliosEvolution,
            changeModalOption,
            immGlobalPosition,
        } = this.props;

        let link = null;

        if (
            !!selectedPortfolio &&
            selectedPortfolio !== EVOLUTION_MODAL_OPTION_TOTAL
        ) {
            const linkURL = immGlobalPosition.getIn([
                'portfolios',
                selectedPortfolio,
                'hasGoal',
            ])
                ? `${GOAL_TRACKING_URL}/${selectedPortfolio}`
                : `${PORTFOLIO_TRACKING_URL}/${selectedPortfolio}`;
            link = (
                <OKLink to={linkURL} modifier="widget">
                    <FormattedText value="raPortfolioEvolution-raPortfolioEvolution_modalLink" />
                </OKLink>
            );
        }

        return (
            <ModalCustom
                isOpen={this.state.showModal}
                onRequestClose={this.handleDisplayModal}
            >
                <div className="ra-portfolio-evolution__modal">
                    <div className="ra-portfolio-evolution__modal-header">
                        <div className="ra-portfolio-evolution__modal-title">
                            <FormattedText value="raPortfolioEvolution-raPortfolioEvolution_modalTitle" />
                        </div>
                        <div className="ra-portfolio-evolution__modal-selector">
                            <RAPortfolioSelector
                                onChangeOption={changeModalOption}
                                options={portfoliosEvolution}
                                selectedPortfolio={selectedPortfolio}
                                isEvolutionModal={true}
                            />
                        </div>
                    </div>
                    <RAEvolutionChart
                        data={modalData}
                        selectedOption={selectedOption}
                        disabled={modalDisabled}
                        isModal={true}
                    />
                    <div className="ra-portfolio-evolution__modal-footer">
                        {link}
                    </div>
                </div>
            </ModalCustom>
        );
    }

    buildEmptyEvolutionModal() {
        return (
            <RAInformativeModal
                isModalOpen={this.state.showEmptyEvolutionModal}
                onModalClose={this.handleDisplayEmptyEvolutionModal}
                textKey="raEmptyEvolutionModal"
            />
        );
    }

    buildEvolutionLink(evolutionLink) {
        return (
            <div className="ra-portfolio-evolution__header-link">
                <OKLink onClick={this.handleDisplayModal} modifier="emphasize">
                    {evolutionLink}
                </OKLink>
            </div>
        );
    }

    getChartSection() {
        const {
            data,
            disabled,
            error,
            goalProgress,
            isObjectiveTracking,
            loading,
            objAmount,
            selectedOption,
            hasRoboNotHired,
        } = this.props;

        let content;
        if (loading) {
            content = <LoadingSection />;
        } else if (error) {
            content = (
                <EmptyState
                    primaryText={formatText(
                        'raObjectiveTracking-raObjectiveTracking_apiFailure',
                    )}
                    iconType="nointernet-wealth"
                />
            );
        } else {
            const isGraphDisabled =
                disabled || isEmpty(data) || data.length < 2;
            content = (
                <RAEvolutionChart
                    data={data}
                    selectedOption={selectedOption}
                    disabled={isGraphDisabled}
                    goalProgress={goalProgress}
                    objAmount={objAmount}
                    isObjectiveTracking={isObjectiveTracking}
                    hasRoboNotHired={hasRoboNotHired}
                />
            );
        }
        return content;
    }

    getDescription() {
        const {
            data,
            description,
            isObjectiveTracking,
            hasRoboNotHired,
        } = this.props;
        let content = description;
        const isDataEmpty = isEmpty(data) || data.length < 2;
        if ((isObjectiveTracking || !hasRoboNotHired) && isDataEmpty) {
            content = (
                <OKLink
                    onClick={this.handleDisplayEmptyEvolutionModal}
                    modifier="complementary"
                >
                    <FormattedText value="raEmptyEvolutionModal-raEmptyEvolutionModal_link" />
                </OKLink>
            );
        }

        return content;
    }

    render() {
        const {
            title,
            description,
            evolutionLink,
            showLink,
            data,
        } = this.props;

        const noData = isEmpty(data) || data.length < 2;
        const evolutionLinkElement =
            showLink &&
            !!evolutionLink &&
            !noData &&
            this.buildEvolutionLink(evolutionLink);
        const evolutionModal = !!evolutionLink && this.buildModal();
        const emptyEvolutionModal = this.buildEmptyEvolutionModal();
        const chartSection = this.getChartSection();

        const titleElement = !!title && (
            <h3 className="ra-portfolio-evolution__title">{title}</h3>
        );
        const descriptionElement = !!description && (
            <p className="ra-portfolio-evolution__description">
                {this.getDescription()}
            </p>
        );

        const el = (
            <div className="ra-portfolio-evolution">
                <div className="ra-portfolio-evolution__modal-container">
                    {evolutionModal}
                </div>
                <header className="ra-portfolio-evolution__header">
                    {titleElement}
                </header>
                <div className="ra-portfolio-evolution__description-container">
                    {descriptionElement}
                    {evolutionLinkElement}
                </div>
                {chartSection}
                {emptyEvolutionModal}
            </div>
        );

        return el;
    }
}

RAPortfolioEvolution.propTypes = {
    changeModalOption: PropTypes.func,
    data: PropTypes.array.isRequired,
    description: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    disabled: PropTypes.bool,
    modalDisabled: PropTypes.bool,
    error: PropTypes.bool,
    evolutionLink: PropTypes.string,
    goalProgress: PropTypes.number,
    immGlobalPosition: PropTypes.object,
    isObjectiveTracking: PropTypes.bool,
    loading: PropTypes.bool,
    modalData: PropTypes.array,
    objAmount: PropTypes.number,
    pgSection: PropTypes.bool,
    portfoliosEvolution: PropTypes.object,
    selectedOption: PropTypes.string.isRequired,
    selectedPortfolio: PropTypes.string,
    showLink: PropTypes.bool,
    title: PropTypes.string,
    hasRoboNotHired: PropTypes.bool,
    onEmptyEvolutionLinkClick: PropTypes.func,
};

RAPortfolioEvolution.defaultProps = {
    disabled: false,
    error: false,
    loading: false,
    isObjectiveTracking: false,
    showLink: false,
    hasRoboNotHired: false,
    onEmptyEvolutionLinkClick: () => {},
};

module.exports = RAPortfolioEvolution;
